<template>
  <div class="sidebar" :class="{ 'is-searching': filtroMenu.trim().length > 0 }">
    <SidebarHeader/>
    <SidebarForm/>
    
    <!-- Caixa de Busca do Menu (Premium) -->
    <div class="sidebar-search-box px-3 py-2">
      <div class="search-input-wrapper">
        <i class="fa fa-search search-icon text-muted"></i>
        <input 
          type="text" 
          v-model="filtroMenu" 
          class="search-input" 
          placeholder="Buscar no menu..."
          autocomplete="off"
          autocorrect="off"
          autocapitalize="off"
          spellcheck="false"
        />
        <i v-if="filtroMenu" class="fa fa-times-circle clear-icon text-muted" @click="filtroMenu = ''"></i>
      </div>
    </div>

    <nav class="sidebar-nav">
      <div slot="header"></div>
      <ul class="nav">
        <template v-for="(item, index) in filteredNavItems">
          <template v-if="item.title">
            <SidebarNavTitle :name="item.name" :classes="item.class" :wrapper="item.wrapper"/>
          </template>
          <template v-else-if="item.divider">
            <SidebarNavDivider :classes="item.class"/>
          </template>
          <template v-else-if="item.label">
            <SidebarNavLabel :name="item.name" :url="item.url" :icon="item.icon" :label="item.label" :classes="item.class"/>
          </template>
          <template v-else>
            <template v-if="item.children">
              <!-- First level dropdown -->
              <SidebarNavDropdown :name="item.name" :url="item.url" :icon="item.icon">
                <template v-for="(childL1, index) in item.children">
                  <template v-if="childL1.children">
                    <!-- Second level dropdown -->
                    <SidebarNavDropdown :name="childL1.name" :url="childL1.url" :icon="childL1.icon">
                      <li class="nav-item" v-for="(childL2, index) in childL1.children">
                        <SidebarNavLink :name="childL2.name" :url="childL2.url" :icon="childL2.icon" :badge="childL2.badge" :variant="item.variant"/>
                      </li>
                    </SidebarNavDropdown>
                  </template>
                  <template v-else>
                    <SidebarNavItem :classes="item.class">
                      <!-- ISLO : REMOVI O ICONE DO MENO FILHO PQ FICAVA BAGUNCANDO TUDO
                      <SidebarNavLink :name="childL1.name" :url="childL1.url" :icon="childL1.icon" :badge="childL1.badge" :variant="item.variant"/>
                      -->
                      <SidebarNavLink :name="childL1.name" :url="childL1.url"  :badge="childL1.badge" :variant="item.variant"/>
                    </SidebarNavItem>
                  </template>
                </template>
              </SidebarNavDropdown>
            </template>
            <template v-else>
              <SidebarNavItem :classes="item.class">
                <SidebarNavLink :name="item.name" :url="item.url" :icon="item.icon" :badge="item.badge" :variant="item.variant"/>
              </SidebarNavItem>
            </template>
          </template>
        </template>
      </ul>
      <slot></slot>
    </nav>
    <SidebarFooter/>
    <SidebarMinimizer/>
  </div>
</template>
<script>
import SidebarFooter from './SidebarFooter'
import SidebarForm from './SidebarForm'
import SidebarHeader from './SidebarHeader'
import SidebarMinimizer from './SidebarMinimizer'
import SidebarNavDivider from './SidebarNavDivider'
import SidebarNavDropdown from './SidebarNavDropdown'
import SidebarNavLink from './SidebarNavLink'
import SidebarNavTitle from './SidebarNavTitle'
import SidebarNavItem from './SidebarNavItem'
import SidebarNavLabel from './SidebarNavLabel'
export default {
  name: 'sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data () {
    return {
      filtroMenu: ''
    }
  },
  computed: {
    filteredNavItems() {
      if (!this.filtroMenu) {
        return this.navItems
      }

      const query = this.filtroMenu.toLowerCase().trim()

      const filterItem = (item) => {
        if (item.divider) {
          return null
        }

        if (item.title) {
          return null
        }

        const nameMatches = item.name && item.name.toLowerCase().includes(query)

        if (item.children) {
          const filteredChildren = item.children
            .map(child => filterItem(child))
            .filter(child => child !== null)

          if (filteredChildren.length > 0) {
            return {
              ...item,
              children: filteredChildren
            }
          }
        }

        if (nameMatches) {
          return item
        }

        return null
      }

      return this.navItems
        .map(item => filterItem(item))
        .filter(item => item !== null)
    }
  },
  components: {
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNavDivider,
    SidebarNavDropdown,
    SidebarNavLink,
    SidebarNavTitle,
    SidebarNavItem,
    SidebarNavLabel
  },
  methods: {
    handleClick (e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
    }
  }
}
</script>

<style lang="css">
  .nav-link {
    cursor:pointer;
  }
  /** ISLO CRIEI ESSE ESTILO PARA DIMINUIR O ESPAÇO ENTRE O ICONE DO MENU E O TEXTO MAIS PARA A ESQUERDA
     DAR COR AO ICONE DO MENU AZUL MAIS CLARO
     A VERSÃO ORIGINAL NÃO TEM ESSE ESTILO, BASTA REMOVER */
  .sidebar .nav-link i {
    width: 10px;
    color: #63c2de !important;
  }
  /** ISLO CRIEI ESSE ESTILO PARA COLORIR O ITEM DO MENU SELECIONADO
     A VERSÃO ORIGINAL NÃO TEM ESSE ESTILO, BASTA REMOVER */
  .sidebar .nav-link.active {
    background: #1d4b8b !important;
  }

  /* Esconder caixa de busca quando o menu estiver minimizado */
  body.sidebar-minimized .sidebar-search-box {
    display: none !important;
  }

  /* Estilização Premium para Caixa de Busca */
  .sidebar-search-box {
    border-bottom: 1px solid rgba(255, 255, 255, 0.04) !important;
    padding: 10px 15px !important;
  }
  .search-input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.22) !important;
    border: 1px solid rgba(0, 0, 0, 0.3) !important;
    border-radius: 6px;
    padding: 6px 10px;
    transition: all 0.2s ease;
  }
  .search-input-wrapper:hover,
  .search-input-wrapper:focus-within {
    background-color: rgba(0, 0, 0, 0.3) !important;
    border-color: rgba(255, 255, 255, 0.05) !important;
  }
  .search-icon {
    font-size: 0.85rem;
    margin-right: 8px;
    color: rgba(255, 255, 255, 0.35) !important;
  }
  .search-input {
    border: 0 !important;
    border-style: none !important;
    background: transparent !important;
    background-color: transparent !important;
    box-shadow: none !important;
    color: #e2e8f0 !important;
    font-size: 0.85rem;
    width: 100%;
    outline: 0 !important;
    outline: none !important;
    outline-width: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
    appearance: none !important;
  }
  .search-input:focus,
  .search-input:focus-visible,
  .search-input:active {
    border: 0 !important;
    border-style: none !important;
    background: transparent !important;
    background-color: transparent !important;
    box-shadow: none !important;
    outline: 0 !important;
    outline: none !important;
    outline-width: 0 !important;
    -webkit-appearance: none !important;
    appearance: none !important;
  }
  .search-input::placeholder {
    color: rgba(255, 255, 255, 0.3) !important;
  }
  .clear-icon {
    font-size: 0.85rem;
    cursor: pointer;
    margin-left: 8px;
    color: rgba(255, 255, 255, 0.3) !important;
    transition: color 0.15s ease;
  }
  .clear-icon:hover {
    color: #ffffff !important;
  }

  /* Auto-abrir dropdowns e exibir itens na busca */
  .sidebar.is-searching .nav-dropdown {
    display: block !important;
  }
  .sidebar.is-searching .nav-dropdown-items {
    max-height: 2500px !important;
    opacity: 1 !important;
    visibility: visible !important;
    display: block !important;
  }
  .sidebar.is-searching .nav-item {
    display: block !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar/Sidebar.vue